import release from './env.release.js'
import test from './env.test.js'
import local from './env.local.js'

let env = null
if (process.env.NODE_ENV === 'production') {
    env = release
}  else if (process.env.NODE_ENV === 'testing') {
    env = test
} else {
    env = local
}
export default env



// WEBPACK FOOTER //
// ./src/env.js